import { IconButton, Image } from "@chakra-ui/react";
import { stringShowExported } from "../strings";
import IconEye from "../assets/icons/eye.svg";
import IconEyeOff from "../assets/icons/eye-off.svg";
import Tooltip from "./tooltip";

type ShowExportedToggleProps = {
  showExported: boolean;
  setShowExported: (value: boolean) => void;
  hasExportedItems: boolean;
};

const ShowExportedToggle = ({
  showExported,
  setShowExported,
  hasExportedItems,
}: ShowExportedToggleProps) => {
  if (!hasExportedItems) return null;

  return (
    <Tooltip label={stringShowExported}>
      <IconButton
        variant="outline"
        backgroundColor={!showExported ? "gray.100" : undefined}
        data-filter-active={!showExported ? "true" : "false"}
        aria-label={stringShowExported}
        icon={
          <Image boxSize="20px" src={showExported ? IconEye : IconEyeOff} />
        }
        onClick={() => setShowExported(!showExported)}
      />
    </Tooltip>
  );
};

export default ShowExportedToggle;
